import { ButtonStyle } from '@davidlloydleisure/common-js-frontend';

import {
  RedesignButtonStyle,
  RedesignHarbourButtonStyle,
  RedesignMeridianButtonStyle,
} from 'src/enums/button-style';

export const buttonStyles = (
  style: RedesignButtonStyle | RedesignMeridianButtonStyle | RedesignHarbourButtonStyle
) => {
  switch (style) {
    case RedesignButtonStyle.PLUM:
    case RedesignMeridianButtonStyle.ORANGE:
    case RedesignHarbourButtonStyle.HARBOUR_GREY_WITH_WHITE_FONT:
      return ButtonStyle.PRIMARY;
    case RedesignButtonStyle.TRANSPARENT_WITH_PLUM_FONT:
    case RedesignMeridianButtonStyle.TRANSPARENT_WITH_BLUE_FONT_AND_BORDER:
    case RedesignHarbourButtonStyle.TRANSPARENT_WITH_GREY_FONT_AND_BORDER:
      return ButtonStyle.TRANSPARENT;
    case RedesignButtonStyle.TRANSPARENT_WITH_WHITE_FONT:
    case RedesignMeridianButtonStyle.TRANSPARENT_WITH_WHITE_FONT_AND_BORDER:
    case RedesignHarbourButtonStyle.TRANSPARENT_WITH_GOLD_FONT_AND_BORDER:
      return ButtonStyle.SECOND_TRANSPARENT;
    case RedesignButtonStyle.DARK_GREEN:
    case RedesignMeridianButtonStyle.BLUE:
      return ButtonStyle.SECOND_PRIMARY;
    case RedesignButtonStyle.WHITE_WITH_GREEN_FONT:
    case RedesignMeridianButtonStyle.WITHOUT_BORDERS_WITH_BLUE_FONT:
      return ButtonStyle.SECOND_SECONDARY;
    case RedesignButtonStyle.WHITE_WITH_PLUM_FONT:
    case RedesignMeridianButtonStyle.WITHOUT_BORDERS_WITH_WHITE_FONT:
    case RedesignHarbourButtonStyle.WHITE_WITH_HARBOUR_GREY_FONT:
      return ButtonStyle.SECONDARY;
    default:
      throw new Error(`No button style found for ${style as string}`);
  }
};
